export default "__VITE_ASSET__DxRKehem__"